import React, { useContext, useEffect, useState } from 'react';
import { Empty } from 'antd';

import {
  Device,
  EventRange,
} from '@totem/components/controlSystemReport/dataTypes';
import DevicesSubTable from '@totem/components/controlSystemReport/DevicesSubTable';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { isNotNull, isNull } from '@totem/utilities/common';
import { CONTROL_SYSTEM_REPORT } from '@totem/utilities/endpoints';

type Props = {
  controlSystemId: string;
  eventRange: EventRange;
};

const DevicesContainer = ({ controlSystemId, eventRange }: Props) => {
  const { getApiToken } = useContext(UserProfileContext);
  const [data, setData] = useState<Device[]>([]);

  useEffect(() => {
    fetch(`${CONTROL_SYSTEM_REPORT}/${controlSystemId}/devices`, {
      method: 'GET',
      headers: new Headers({
        Authorization: `Bearer ${getApiToken()}`,
      }),
    })
      .then((res) => res.json())
      .then((result: Device[]) => {
        if (result.length > 0) {
          setData(result);
        }
      });
  }, [controlSystemId, getApiToken]);

  if (isNull(data) || data.length === 0) {
    return <Empty />;
  }

  return (
    <DevicesSubTable
      devices={isNotNull(data) && data.length > 0 ? data : []}
      loading={false}
      eventRange={eventRange}
    />
  );
};

export default DevicesContainer;
